function Company() {
  return (
    <section className="section company-section" id="company">
      <div className="container">
        <div className="section-head reveal">
          <p className="section-label">COMPANY</p>
          <h2 className="section-title">会社概要</h2>
          <p className="section-desc">
            NAGARA container 運営会社情報
          </p>
        </div>

        <dl className="company-table">

          <div className="company-row">
            <dt>ブランド名</dt>
            <dd>NAGARA container</dd>
          </div>

          <div className="company-row">
            <dt>運営会社</dt>
            <dd>合同会社 ナガラワークス</dd>
          </div>

          <div className="company-row">
            <dt>MAIL</dt>
            <dd>nagaraworks.gujo@gmail.com</dd>
          </div>

          <div className="company-row">
            <dt>TEL</dt>
            <dd>0575-82-6870</dd>
          </div>

          <div className="company-row">
            <dt>郡上事務所 & モデルルーム</dt>
            <dd>
              〒501-5126<br />
              岐阜県郡上市白鳥町向小駄良722-2
            </dd>
          </div>

          <div className="company-row">
            <dt>郡上工場</dt>
            <dd>
              〒501-4601<br />
              岐阜県郡上市白鳥町那留焼原63-1
            </dd>
          </div>

          <div className="company-row">
            <dt>岐阜オフィス</dt>
            <dd>
              〒502-0929<br />
              岐阜県岐阜市則武東2-4-7
            </dd>
            </div>

        </dl>
      </div>
    </section>
  );
}

export default Company;
